import React from "react";
import { shape, func, bool, string } from "prop-types";
import { Link } from "@quintype/components";

const MenuItem = ({ item, itemClick }) => {
  if (item["item-type"] === "placeholder") {
    return <span>{item.title}</span>;
  } else if (item["item-type"] === "link") {
    return (
      <a aria-label={item.title} href={item.completeUrl} onClick={itemClick}>
        {item.title}
      </a>
    );
  } else {
    return (
      <Link aria-label={item.title} href={item.completeUrl} callback={itemClick}>
        {item.title}
      </Link>
    );
  }
};

MenuItem.propTypes = {
  item: shape({
    isExternalLink: bool,
    completeUrl: string,
    title: string,
  }),
  itemClick: func,
  dataTagCategory: string,
};

export { MenuItem };
